module.exports = __webpack_public_path__ + "static/media/lv.fcee18be.svg";